import React, { Component } from "react";
import axios from "axios";
import { Contact, PageHeader, WebinarListBody } from "../components";
import { API_EVENTS, API_MAIN, API_WEBINARS } from "../utils/constants";

const webinarPageText = {
  id: {
    title: "Webinar",
    subtitle: "Daftar webinar dan event yang telah diselenggarakan oleh tim kami.",
  },
  en: {
    title: "Webinars",
    subtitle: "A list of webinars and events that have been conducted by our team.",
  },
};

export class Webinar_list extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      main: [],
      total: 4,
      perpage: 2,
    };
  }

  componentDidMount() {
    this.getItems(this.props.match.params.page || 1);
    this.getMain();
  }

  componentDidUpdate(prevProps) {
    const currentPage = this.props.match.params.page;
    const prevPage = prevProps.match.params.page;

    if (currentPage !== prevPage) {
      this.getItems(currentPage || 1);
    }
  }

  getMain() {
    axios
      .get(API_MAIN)
      .then((res) => {
        this.setState({ main: res.data.main });
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getItems(page) {
    axios
      .get(`${API_WEBINARS}?pagin=${page}`)
      .then((res) => {
        const events = res.data.webinars || [];
        this.setState({
          items: events,
          total: res.data.total || events.length || 0,
          perpage: res.data.limit_per_page || events.length || 2,
        });
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const { items, main, total, perpage } = this.state;
    const lang = window.lang || "id";
    const copy = webinarPageText[lang] || webinarPageText.id;
    const param = {
      title: copy.title,
      subtitle: copy.subtitle,
      breadcrumb: copy.title,
    };

    return (
      <main>
        <div role="main" className="main">
          <PageHeader param={param} />
          <WebinarListBody
            items={items}
            page={this.props.match.params.page || 1}
            total={total}
            perpage={perpage}
          />
          <Contact data={main} />
        </div>
      </main>
    );
  }
}

export default Webinar_list;
